import { cn } from '../../../shared/utils/cn'

const inputBase =
  'w-full h-9 px-3 py-2 bg-white rounded-md border text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-1'

export const inputClass = cn(inputBase, 'border-gray-200 focus:ring-primary-500 focus:border-primary-500')

export const inputErrorClass = cn(inputBase, 'border-red-300 focus:ring-red-500 focus:border-red-500')

export const labelClass = 'text-sm font-medium text-gray-900'

export const errorClass = 'text-xs text-red-500 mt-1'

export const SECTIONS = [
  { id: 'general', label: 'General', toggleable: false },
  { id: 'location', label: 'Location', toggleable: false },
  { id: 'ticket_sales', label: 'Ticket sales', toggleable: true },
  { id: 'early_access', label: 'Early Access', toggleable: true },
  { id: 'presale', label: 'Ticket pre-sales', toggleable: true },
  { id: 'vip', label: 'VIP ticket sales', toggleable: true },
  { id: 'addons', label: 'Event Add-On', toggleable: true }
] as const

export const fieldInputClass = (field: string, errors: Record<string, string>): string =>
  errors[field] ? inputErrorClass : inputClass
